<template>
    <div class="navs-fixed">
      <div class="nav-center">
        <div class="navs-back" @click.stop="_back"><i class="el-icon-arrow-left" /></div>
        <div v-if="title!='index'">{{title}}</div>
        <div v-else><img  :src="this.globalConfig.imgUrl+logo" class="nav-log"></div>
        <div class="nav-record" v-if="this.$route.path!='/THAL/recordBet'" @click.stop="_record_next"><i class="el-icon-document"></i></div>
        <div class="nav-amount">
          <div>{{username}}</div>
          <div>{{phone}}</div>
          <div>{{$t('login.amount')}} {{balance}}</div>
        </div>
      </div>

    </div>
</template>

<script>
    export default {
        name: "navs",
      props:['title',''],
      data(){
          return{
            logo:'',
            username:'',
            balance:'',
            phone:''
          }
      },
      created:function(){
          let that=this;
          that._user();
          that._config();
      },
      methods:{
        _record_next:function (){
          let _self=this;
          if(_self.$route.path!='/THAL/recordBet'){
            _self.$router.push({path:'/THAL/recordBet'})

          }
        },
        _config:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'site/config', {}, function (result) {
            if(result.data['status_code']==200){
              _self.logo=result.data['data'].logo;
            }
          })
        },
        _back:function () {
          this.$router.back();
        },
        _user:function () {
          let _self=this;
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            this._PublicFun.getData('2', 'get', 'user', {}, function (result) {
              if(result.data['status_code']==200){
                _self.GLOBAL.save('user',result.data['data']);
                _self.username=result.data['data'].username;
                _self.balance=result.data['data'].balance;
                _self.phone=result.data['data'].phone;
                _self.withdraw_bet_quota=result.data['data'].withdraw_bet_quota;

              }

            })
          }else{
            _self.isToken=false;
          }
        },
      }
    }
</script>

<style scoped>
  .navs-fixed{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 55px;
    z-index: 9;
    display: flex;
    color: #ffffff;
    background-color: #2D2D2D;
    align-items: center;
  }
  .nav-center{
    display: flex;
    width: 100%;max-width: 750px;
    margin: 0 auto;
    padding: 0;
    align-items: center;
    position: relative;
    height: 100%;
  }
  .navs-back{
    font-size: 20px;
    color: #F6D989;
    margin-left: 5px;
    cursor: pointer;

  }
  .nav-log{
    height: 50px;
    width: auto;
    margin: 0 5px;
  }
  .nav-amount{
    position: absolute;
    right: 10px;
    top: 50%;
    font-size: 12px;
    border: 1px solid #F6D989;
    border-radius: 5px;
    padding: 0 5px;
    zoom: 0.8;
    transform: translateY(-50%);
  }
  .nav-amount div:first-child{
    color: #F6D989;
  }
  .nav-record{
    position: absolute;
    right: 90px;
    top: 50%;
    transform: translateY(-50%);
    color: #FFFFFF;
    font-size: 25px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/THAL/navs.vue